import { CONFIG } from './config'

export const VALIDGUESSES = [
  'niibin',
  'aanind',
  'maampii',
  'maaskaa',
  'nimosh',
  'bangii',
  'giigoonh',
  'bgiza',
  'gaawiin',
  'nahaaw',
  'aabdek',
  'aabnaan',
  'aabshkaa',
  'biidoon',
  'bmoode',
  'aadoowii',
  'aadshin',
  'begish',
  'bmaashi',
  'aakzin',
  'aandbi',
  'aanawii',
  'aandek',
  'aandkii',
  'aandse',
  'bngwi',
  'chaawse',
  'dzhiike',
  'aasnaan',
  'aasooke',
  'aatebii',
  'aatese',
  'aawdoon',
  'aawnsa',
  'aazhbik',
  'aazhgan',
  'bizaan',
  'bizwaa',
  'bweza',
  'daawen',
  'daawmaa',
  'gaawaanh',
  'waaswaa',
  'ninda',
  'esban',
  'ezgaak',
  'eshkam',
  'gonda',
  'neniizh',
  'goodoon',
  'goojin',
  'gozhen',
  'gzhiza',
  'gkina',
  'gwaawe',
  'jidmoo',
  'waagosh',
  'yekzi',
  'gegpii',
  'geget',
  'giinwi',
  'zhoomin',
  'daabaan',
  'giiwenh',
  'gsinaa',
  'zhiishiib',
  'gaapzi',
  'dkate',
  'giizis',
  'gaachin',
  'gaawye',
  'mnidoo',
  'ngoji',
  'zgime',
  'shoogan',
  'mookse',
  'zhebwe',
  'gnimaa',
  'nagish',
  'pakne',
  'oodetoo',
  'noojmo',
  'kakzhe',
  'maamwi',
  'sabaap',
  'wesiinh',
  'maapiich',
  'wenesh',
  'engaach',
  'gbagaa',
  'miijim',
  'biiway',
  'zhaabwii',
  'giigda',
  'maajtaa',
  'neyaap',
  'penmo',
  'wewiip',
  'zoogpo',
  'bkade',
  'niwin',
  'debse',
  'maanda',
  'wiidge',
  'giiwse',
  'waasmo',
  'mdida',
  'jaagde',
  'boontaa',
  'nookzi',
  'wiigop',
  'oojiins',
  'zhkipo',
  'bzhiki',
  'niibna',
  'shagwe',
  'waawan',
  'zaawzi',
  'kawesh',
  'jiimaan',
  'nishin',
  'shkode',
  'washme',
  'zhanda',
  'kojiish',
  'jiibay',
  'niinwi',
  'shkwaach',
  'zhashki',
  'jiibik',
  'waaboos',
  'nshike',
  'maagzhaa',
  'miigwe',
  'shange',
  'zhebza',
  'pagza',
  'jijaak',
  'magkii',
  'waabzii',
  'siikzi',
  'wiiyaas',
  'zhichge',
  'miikse',
  'zaambii',
  'jaagse',
  'gzhiiwe',
  'miijin',
  'niiwin',
  'zegzi',
  'maandaa',
  'gzike',
  'njida',
  'jibwaa',
  'shtaahaa',
  'webtaa',
  'zhitoon',
  'megwaa',
  'wenen',
  'zenbaa',
  'mkawi',
  'wiinno',
  'zhoonyaa',
  'nmanj',
  'bbagaa',
  'debwe',
  'mdaabii',
  'wiinan',
  'beskaa',
  'dkibi',
  'ziigse',
  'wiinge',
  'nsing',
  'bekish',
  'mdoodoo',
  'gaachmo',
  'wiinat',
  'zhngop',
  'noomya',
  'bkaagii',
  'giisaach',
  'zzagaa',
  'naasaap',
  'waaban',
  'giimooch',
  'miikan',
  'waawaach',
  'wiikse',
  'nawach',
  'gnwesh',
  'neyiizh',
  'wiikenh',
  'zhaabooz',
  'aabdat',
  'dnawa',
  'gaazhak',
  'maamaanh',
  'wiisni',
  'gaadoon',
  'zhiishiip',
  'wiinzi',
  'pabin',
  'noogse',
  'zhedbi',
  'niikmo',
  'shkose',
  'ziigbii',
  'niibiish',
  'ziigzi',
  'koojiish',
  'dching',
  'zhngos',
  'bkobii',
  'dsooza',
  'biinzi',
  'geniin',
  'mgizi',
  'nanda',
  'shigan',
  'washta',
  'zkide',
  'baazmaa',
  'dkaji',
  'gtaaji',
  'maazhbii',
  'bejtaa',
  'dkamii',
  'mzhishi',
  'waasiinh',
  'njigaa',
  'dikon',
  'biigza',
  'dkaashi',
  'gdoode',
  'mbaashi',
  'biinat',
  'waayaak',
  'nootaan',
  'zaagkii',
  'gdaashi',
  'mooday',
  'bmena',
  'nshiwe',
  'zasaan',
  'giibse',
  'boonse',
  'wiinwaa',
  'ziiwan',
  'nwanj',
  'giipzi',
  'zhoowbii',
  'piszi',
  'sabke',
  'nsooza',
  'giizhge',
  'ektaan',
  'dshing',
  'ziiwzi',
  'nshitoo',
  'gbeshi',
  'booskaa',
  'daakaan',
  'bikan',
  'baapish',
  'jikenh',
  'maakzi',
  'nbiikaa',
  'biiwan',
  'mskwi',
  'jiiskii',
  'mbigi',
  'negaw',
  'boonam',
  'jiitat',
  'migzhe',
  'nbagaa',
  'jiigke',
  'baaskaa',
  'mshkiig',
  'gookoosh',
  'bmase',
  'boonpo',
  'gechwaa',
  'giikji',
  'giibaach',
  'gmaapii',
  'gnoozhe',
  'gmoodi',
  'godaas',
  'gnooyaa',
  'gnooonaa',
  'gnamaa',
  'gnoonaa',
  'gtimi',
  'gtige',
  'gzaabii',
  'gzhaate',
  'gzhide',
  'jenjii',
  'maamdaa',
  'miigis',
  'mzise',
  'naadin',
  'naajmo',
  'naagan',
  'chaashin',
  'naanan',
  'miinan',
  'damna',
  'bnesi',
  'bnise',
  'damzi',
  'dbasaa',
  'dbakii',
  'dende',
  'dikmi',
  'tisge',
  'dkaaboo',
  'daawni',
  'dkokii',
  'dnakii',
  'dkoozi',
  'dnizi',
  'doodaan',
  'dpaabi',
  'ebgoonh',
  'kidan',
  'bezhik',
  'gaadaan',
  'dzhitaa',
  'gaachte',
  'eshkan',
  'gegwa',
  'gekaanh',
  'giipzi',
  'giimshe',
  'giiwzi',
  'giinwaa',
  'gnige',
  'gzhiibii',
  'gzhiikaa',
  'gyaashk',
  'jaagza',
  'jiisan',
  'kaawiin',
  'kanaak',
  'kanan',
  'kogaan',
  'maajaan',
  'mekde',
  'miikzi',
  'moowich',
  'mwizo',
  'mskwaa',
  'naagshi',
  'naagach',
  'naabza',
  'naapne',
  'noongo',
  'nagsha',
  'nbooke',
  'niibwa',
  'niiwaak',
  'nishkaa',
  'nishke',
  'nonda',
  'noodin',
  'nswaak',
  'bwiins',
  'zegtaa',
  'zaakam',
  'zhaabbii',
  'zhebtoo',
  'zhaabza',
  'zhegwaa',
  'zhiigon',
  'zhedbi',
  'zhigni',
  'shpizi',
  'samzi',
  'miinan',
  'niigaan',
  'miijin',
  'biinji',
  'chaashin',
  'tkoozi',
  'gnoozhi',
  'naanan',
  'baabiiaa',
  'boodwe',
  'noodin',
  'bmase',
  'bmose',
  'tawag',
  'towag',
  'tkozi',
  'gzhaate',
  'gzhide',
  'nahaw',
  'nahow',
  'tegin',
  'giinwaa',
  'gnamaa',
  'naagach',
  'kogaak',
  'wiikwii',
  'biidook',
  'shkwaach',
  'miigsha',
  'miigis',
  'sabaap',
  'baapin',
  'zhiitaak',
  'shamik',
  'gmoodi',
  'tedik',
  'zhitoon',
  'zhitood',
  'miptoo',
  'miinwaa',
  'mbizo',
  'makwa',
  'mkade',
  'gonda',
  'ninda',
  'mziwe',
  'giizhik',
  'miptoo',
  'getin',
  'epiichi',
  'daanis',
  'ngashi',
  'bmose',
  'bezhik',
  'zookpo',
  'patoon',
  'patook',
  'miinan',
]

if (CONFIG.normalization) {
  VALIDGUESSES.forEach(
    (val, i) => (VALIDGUESSES[i] = val.normalize(CONFIG.normalization))
  )
}
